import { apiFetch } from '@/lib/api';

export interface SeaVentVenue {
  cvent_venue_id: string | null;
  cvent_venue_code: string | null;
  name: string | null;
  city: string | null;
  country: string | null;
  address: string | null;
  state_province: string | null;
}

export class SeaVentService {
  async search(name: string, city: string, country?: string): Promise<SeaVentVenue[]> {
    const params = new URLSearchParams({ name: name.trim(), city: city.trim() });
    if (country && country.trim()) params.set('country', country.trim());

    const res = await apiFetch(`/api/seavent/search?${params.toString()}`);
    if (!res.ok) {
      try {
        const payload = await res.json();
        throw new Error(payload?.error?.message || 'SeaVent search failed');
      } catch {
        throw new Error('SeaVent search failed');
      }
    }
    const data = await res.json();
    return (data?.data?.items || []) as SeaVentVenue[];
  }
}









